import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { TFunction } from 'i18next'
import { useMainPageStatsSectionStyles } from './main-page-stats-section.styles'
import { formatSlotValue, StatCellTone, StatsSlot } from './main-page-stats-shared'

export type MainPageStatAsyncCountCellProps = {
  tone: StatCellTone
  slot: StatsSlot | undefined
  /** null = loading; -1 = error (fallback target); >=0 = array length from API */
  asyncCount: number | null
  effectiveTarget: number
  label: string
  /** i18n key passed to t(), e.g. mainPage.stats.loadingNonprofitCount */
  loadingAriaLabelKey: string
  t: TFunction
}

export const MainPageStatAsyncCountCell: React.FC<MainPageStatAsyncCountCellProps> = ({
  tone,
  slot,
  asyncCount,
  effectiveTarget,
  label,
  loadingAriaLabelKey,
  t,
}) => {
  const classes = useMainPageStatsSectionStyles()
  const isLoading = asyncCount === null
  const slotForFormat =
    slot != null ? { ...slot, target: effectiveTarget } : null
  const display =
    slotForFormat != null && !isLoading
      ? formatSlotValue(slotForFormat, effectiveTarget)
      : '—'

  return (
    <div className={`${classes.cell} ${classes[tone]}`}>
      {isLoading ? (
        <div
          className={`${classes.value} ${classes.valuePreloader}`}
          role="status"
          aria-live="polite"
          aria-label={t(loadingAriaLabelKey)}
        >
          <CircularProgress size={40} thickness={4} color="inherit" />
        </div>
      ) : (
        <div className={classes.value}>{display}</div>
      )}
      <div className={classes.label}>{label}</div>
    </div>
  )
}
